import React from 'react'
import RetailerUtilityBox from '@scentregroup/shared/components/retailer-utility-box-v2'
import { generateStoreFrontUrl } from '@scentregroup/shared/helpers/store'
import { TradingHourDay } from '@scentregroup/shared-graphql'
import { CFStore } from '@scentregroup/shared/types/contentful'

type StoreData = Partial<React.ComponentProps<typeof RetailerUtilityBox>> &
  Pick<CFStore, 'sys' | 'slug' | 'title'>

/**
 * utility to transform v2 data to be used in v1 retail utility component
 * due to complexity the retailer utility component has been deprioritised to be updated to HUB.
 */
export function createRetailerUtilityfromStore(
  storeData: StoreData | undefined | null,
  tradingHours: TradingHourDay[] = [],
  timeZone?: string,
  centreSlug?: string
): React.ComponentProps<typeof RetailerUtilityBox> | undefined {
  if (!storeData || tradingHours.length === 0 || !timeZone) {
    return undefined
  }

  const storeLink =
    centreSlug && storeData.sys.id && storeData.slug
      ? `/${centreSlug}${generateStoreFrontUrl(
          storeData?.sys.id,
          storeData?.slug
        )}`
      : undefined

  return {
    ...storeData,
    heading: storeData.title || '',
    storeLink,
    openHours: {
      timeZone,
      storeTradingSchedule: {
        isStoreCentreLinked: true,
        tradingHours,
      },
      centreTradingSchedule: {
        tradingHours,
      },
    },
  }
}
